<template>
    <div class="frame-content">
        <div class="frame-content-wrap">
            <div class="datatable-wrap mt-10">
                <div class="topbar">
                    <div class="inline mr-8">
                        <el-button type="primary" :loading="exportLoading" :disabled="exportLoading" size="small" @click="handleExportList()">导出</el-button>
                    </div>
                </div>
                <div class="datatable">
                    <el-table
                        ref="curChargeTable"
                        :data="tableData"
                        v-loading="tableLoading"
                        element-loading-background="rgba(255, 255, 255, 0.3)"
                        border
                        height="600"
                        style="width: 100%">
                        <!-- <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                        </el-table-column> -->
                        <el-table-column
                            fixed
                            prop="sortNum"
                            label="序号">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="姓名">
                        </el-table-column>
                        <el-table-column
                            prop="numId"
                            label="身份证号"
                            min-width="200">
                        </el-table-column>
                        <el-table-column
                            label="性别">
                            <template slot-scope="scope">
                                {{ scope.row.sex }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="supplierName"
                            label="分包名称"
                            min-width="200">
                        </el-table-column>
                        <el-table-column
                            prop="roomName"
                            label="房间号">
                        </el-table-column>
                        <el-table-column
                            prop="inDate"
                            label="入住日期"
                            min-width="120">
                        </el-table-column>
                        <el-table-column
                            prop="outDate"
                            label="退宿日期"
                            min-width="120">
                        </el-table-column>
                        <el-table-column
                            prop="isDepositText"
                            label="押金是否缴纳"
                            min-width="120">
                        </el-table-column>
                        <el-table-column
                            prop="depositMoney"
                            label="押金缴纳金额"
                            min-width="120">
                        </el-table-column>
                        <el-table-column
                            prop="isReturnText"
                            label="押金是否退还"
                            min-width="120">
                        </el-table-column>
                        <el-table-column
                            prop="deductionMoney"
                            label="扣款金额">
                        </el-table-column>
                        <el-table-column
                            prop="returnMoney"
                            label="退还金额">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
import {exportExcelWithImages} from '@/utils/excelExport'

export default {
    name: 'WorkerDeposit',
    components: {},
    data() {
        return {
            filters: { },

            tableData: [],

            totalNum: 0,
            pageNum: 1,
            pageSize: 10000,

            curPageNum: 1,

            tableLoading: false,
            exportLoading: false,
        };
    },
    created () {
        this.org = this.getCurrentOrg();
        this.loadTable();
    },
    methods: {
        ...common,
        // 加载表格数据
        loadTable() {
            let params = {...this.filters};

            params.projectId = this.$store.state.org.id;
            params.pageNum = this.pageNum;
            params.pageSize = this.pageSize;

            this.tableLoading = true;
            http.get('v1/worker/deposit/list', {
                params: params
            }).then(req => {
                this.tableLoading = false;
                if (req.data.code == http.SUCCESS) {
                    let data = req.data.data;
                    this.tableData = data;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        // 获取导出信息
        handleExportList(){
            this.exportLoading = true;
            this.$nextTick(() => {
                this.handleExport(this.tableData || []);
            });
        },
        async handleExport(exportList){
            try {
                let data = [
                    ['序号', '姓名', '身份证号', '性别', '分包名称', '房间号', '入住日期', '退宿日期', '押金是否缴纳', '押金缴纳金额', '押金是否退还', '扣款金额', '退还金额'],
                ];
                exportList.map((item, index) => {
                    let itemData = [
                            index + 1,
                            item.name,
                            item.numId,
                            item.sex,
                            item.supplierName,
                            item.roomName,
                            item.inDate,
                            item.outDate,
                            item.isDepositText,
                            item.depositMoney,
                            item.isReturnText,
                            item.deductionMoney,
                            item.returnMoney,
                        ]
                    data.push(itemData);
                });
                
                const images = [];
                
                exportExcelWithImages(data, images, `${this.org.name}个人押金信息.xlsx`);
                
                setTimeout(()=>{
                    this.exportLoading = false;
                    this.$message.success('导出成功');
                }, 5000);
            } catch (error) {
                this.exportLoading = false;
                this.$message.error('导出失败');
            }
        }
    }
}
</script>

<style scoped>
</style>
